export default __webpack_public_path__ + "static/media/HauntedDecoderLogo.dc08c547.png";